const ITEMS = [
  "WORLD TIME ATTACK CHALLENGE",
  "BATHURST 12 HR",
  "UNMARKED",
  "ROLL RACING SYDNEY",
  "SESSION AU",
  "CARS AND CULTURE SYDNEY — MOTOR CULTURE AU",
  "SRO GT WORLD CHALLENGE",
  "V8 SUPERCARS",
  "SYDNEY MOTORSPORT PARK",
  "RACE / MOTORSPORT TEAM MEDIA CONTENT",
  "CAR SHOOTS",
  "ROLLERS",
  "CINEMA-GRADE TELEMETRY",
  "SUPERCAR REVEALS",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center">
        <span
          className={`font-display text-3xl md:text-5xl tracking-tight px-6 md:px-10 whitespace-nowrap ${
            i % 2 === 0 ? "text-white" : "text-outline"
          }`}
          style={{ fontWeight: 800 }}
        >
          {item}
        </span>
        <span className="w-2 h-2 md:w-2.5 md:h-2.5 bg-signal rotate-45 shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 bg-ink py-6 md:py-8 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
